import { ExcludeWordsContainer } from '../../containers/advancedFilters/ExcludeWordsContainer';
import { IFilter } from '../../types/advancedFilters';

export const excludeWords: IFilter = {
  component: ExcludeWordsContainer,
};
